// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__Snne2","menu_algo1":"menu_menu_algo1__tfFMG","menu_algo2":"menu_menu_algo2__qEHQJ","menu_algo3":"menu_menu_algo3__BAx6M","header":"menu_header__t+NuG"};